{
  "FormSaveButton": {
    "save": "Save"
  },
  "StickyFormActionsBar": {
    "toolbarLabel": "Form actions",
    "hotkeyHintBefore": "Press",
    "hotkeyHintAfter": "to save changes",
    "cancel": "Cancel"
  },
  "DialogErrorFooter": {
    "error": "Error"
  },
  "FormDialogContent": {
    "save": "Save"
  },
  "ArchiveConfirmationDialog": {
    "archiveTitle": "Archive {{entityName}}?",
    "unarchiveTitle": "Unarchive {{entityName}}?",
    "archiveDescription": "Are you sure you want to archive this {{entityName}}? You will not lose any data.",
    "unarchiveDescription": "Are you sure you want to unarchive this {{entityName}}?",
    "archiveConfirm": "Archive",
    "unarchiveConfirm": "Unarchive",
    "cancel": "Cancel",
    "confirmInProgress": "{{label}}…",
    "confirmRetry": "{{label}} (Retry)",
    "srDescriptionArchive": "Confirmation modal for archiving a {{entityName}}.",
    "srDescriptionUnarchive": "Confirmation modal for unarchiving a {{entityName}}."
  },
  "FileUploadDropzone": {
    "dropFilesOrClickOrPaste": "Drop files here, click to select, or paste",
    "weAccept": "We accept {{formats}}",
    "acceptImages": "images"
  },
  "FinancialDocumentDialog": {
    "addInvoice": "Add invoice",
    "addReceipt": "Add receipt",
    "editInvoice": "Edit invoice",
    "editReceipt": "Edit receipt",
    "create": "Create",
    "invoice": "Invoice",
    "invoices": "Invoices",
    "receipt": "Receipt",
    "receipts": "Receipts",
    "expense": "Expense",
    "expensePlaceholder": "Select expense",
    "reference": "Reference",
    "referencePlaceholder": "Enter reference",
    "amount": "Amount",
    "status": "Status",
    "statusPlaceholder": "Select status",
    "file": "File",
    "fileDescription": "PDF and image formats supported",
    "upload": "Upload",
    "attachedReceipt": "Attached receipt",
    "documentCount": "{{count}} document",
    "documentCount_other": "{{count}} documents",
    "unsavedChanges": "You have unsaved changes in the financial document form.",
    "download": "Download",
    "openInNewTab": "Open in new tab",
    "untitled": "Untitled",
    "noFileAttached": "No file attached",
    "documentSaved": "Document saved",
    "documentDeleted": "Document deleted",
    "documentSaveFailed": "Failed to save document",
    "documentDeleteFailed": "Failed to delete document",
    "allReconciledTooltip": "All documents reconciled: actual equals committed, and every document (excluding those awaiting approval) has status Paid or Approved.",
    "underCommittedTooltip": "Under committed: actual spend is less than the committed amount.",
    "overCommittedTooltip": "Over committed: actual spend exceeds the committed amount."
  },
  "UnsavedChangesDialog": {
    "title": "Unsaved Changes",
    "description": "You have unsaved changes. Are you sure you want to leave? Your changes will be lost.",
    "cancel": "Keep Editing",
    "confirm": "Discard Changes",
    "beforeUnload": "You have unsaved changes. Are you sure you want to leave?"
  },
  "EnumFilterWidget": {
    "operator": {
      "matchAny": "is any of",
      "matchAll": "is all of",
      "matchNone": "is none of",
      "empty": "is empty",
      "notEmpty": "is not empty"
    },
    "searchPlaceholder": "Search for a value",
    "emptyValue": "Select",
    "valueNotRequired": "No values required"
  },
  "DateFilterCustomDialog": {
    "title": "Custom date or timeframe",
    "enterHumanDate": "Enter human date",
    "humanPlaceholder": "e.g. next 7 days, tomorrow, 2025-01-14, Jan 20 - Jan 27",
    "examples": "Examples: “next 7 days”, “tomorrow”, “Jan 20 - Jan 27”",
    "or": "or",
    "setSpecificDate": "Set specific date",
    "single": "Single",
    "range": "Range",
    "clear": "Clear",
    "willApply": "Will apply:",
    "apply": "Apply"
  },
  "DateFilterWidget": {
    "operator": {
      "between": "between",
      "after": "after",
      "before": "before",
      "equal": "on"
    },
    "emptyValue": "Set dates",
    "apply": "Apply",
    "cancel": "Cancel"
  },
  "BooleanFilterWidget": {
    "operator": {
      "is": "is",
      "isNot": "is not"
    }
  },
  "NumberFilterWidget": {
    "title": "Set number",
    "operator": {
      "equal": "is",
      "notEqual": "is not",
      "greaterThan": "greater than",
      "lessThan": "less than",
      "between": "between"
    },
    "to": "to",
    "apply": "Apply",
    "cancel": "Cancel"
  },
  "StringFilterWidget": {
    "operator": {
      "equals": "is",
      "contains": "contains",
      "notContains": "does not contain"
    },
    "placeholder": "Enter value",
    "emptyValue": "Set value",
    "apply": "Apply",
    "cancel": "Cancel",
    "suggestionsIdleHint": "Start typing to search, or choose a recent place below.",
    "suggestionsEmpty": "No matching places. Try a different search.",
    "recentPlacesHeading": "Recent"
  },
  "FilterWidgetAddControl": {
    "manageFilters": "Manage filters",
    "searchPlaceholder": "Search filters…",
    "emptySearch": "No filters match your search"
  },
  "ArchivedTabs": {
    "all": "All",
    "archived": "Archived"
  },
  "ActiveTabs": {
    "active": "Active",
    "inactive": "Inactive"
  },
  "SortableEntityTable": {
    "failedToLoadData": "Failed to load data",
    "selectAllItems": "Select all items",
    "selectItem": "Select {{key}}",
    "actionsSrOnly": "Actions",
    "validationIssueSrOnly": "Validation issue",
    "collapseRow": "Collapse row",
    "expandRow": "Expand row",
    "expandAllRows": "Expand all rows",
    "collapseAllRows": "Collapse all rows",
    "dragToReorder": "Reorder row",
    "locked": "Locked",
    "reorderSrOnly": "Reorder",
    "clearSortToReorder": "Clear sorting to reorder"
  },
  "MediaCarousel": {
    "openMedia": "Open media"
  },
  "MediaLoadStateOverlays": {
    "imageUnavailable": "Image unavailable",
    "videoUnavailable": "Video unavailable"
  },
  "EntityListToolbar": {
    "searchPlaceholder": "Search...",
    "resourcesSearchPlaceholder": "Search resources...",
    "calloutsSearchPlaceholder": "Search callouts...",
    "clearAllFilters": "Clear all filters"
  },
  "EntityGridItem": {
    "noName": "No name"
  },
  "CoreFields": {
    "status": "Status",
    "production_date": "Production Date",
    "code": "Code",
    "archived": "Archived",
    "userId": "Owner",
    "productionTypeId": "Production Type",
    "resource_type_id": "Type",
    "organisation_id": "Organization",
    "represented_by_id": "Agent",
    "role": "Role",
    "tags": "Tags",
    "groups": "Groups",
    "emails": "Emails",
    "phone_numbers": "Phones",
    "websites": "Websites",
    "socials": "Social Media",
    "locations": "Locations",
    "icon": "Icon",
    "color": "Color",
    "title": "Title",
    "description": "Description",
    "budget_amount": "Budget Amount",
    "createdAt": "Created",
    "updatedAt": "Updated"
  },
  "CalloutSpecificFields": {
    "published": "Published",
    "archived": "Archived",
    "slug": "URL slug"
  },
  "ResourceSpecificFields": {
    "groupName": "Resource Specific",
    "contact_type": "Resource Type",
    "emails": "Emails",
    "phones": "Phones",
    "websites": "Websites",
    "socials": "Social Media",
    "user_id": "Owner"
  },
  "ContactTypes": {
    "INDIVIDUAL": "Individual",
    "ORGANIZATION": "Organization",
    "LOCATION": "Location",
    "ITEM": "Item",
    "TALENT": "Talent",
    "AGENT": "Agent"
  },
  "CustomFields": {
    "today": "Today"
  },
  "EntityTypes": {
    "production": "Production",
    "booking": "Booking",
    "resource": "Resource",
    "expense": "Expense"
  },
  "FilterGroups": {
    "coreFields": "Core Fields",
    "customFields": "Custom Fields"
  },
  "ReconciliationsTable": {
    "collapseAllDocuments": "Collapse all documents",
    "expandAllDocuments": "Expand all documents",
    "lineType": "Line type",
    "updatedAt": "Updated",
    "vendorTooltipBooking": "Booking",
    "vendorTooltipBudgetExpense": "Production budget expense",
    "expenseDetailsPopover": {
      "title": "Expense details",
      "vendor": "Vendor",
      "category": "Category",
      "committed": "Committed",
      "actual": "Actual",
      "receipts": "Receipts",
      "edit": "Edit"
    }
  },
  "ReconciliationFilters": {
    "invoice_status": {
      "AWAITING_APPROVAL": "Awaiting approval",
      "APPROVED": "Approved",
      "PAID": "Paid",
      "DECLINED": "Declined"
    }
  },
  "EntityListViewSwitch": {
    "gridView": "Grid view",
    "listView": "List view"
  },
  "EntityListSortSelect": {
    "sort": "Sort",
    "placeholder": "Sort",
    "noSort": "No sort",
    "sortAsc": "(A→Z)",
    "sortDesc": "(Z→A)"
  },
  "EntityGridSelectionToolbar": {
    "selectAllItems": "Select all items"
  },
  "EntityGridListItem": {
    "selectItem": "Select {{key}}",
    "deselectItem": "Deselect {{key}}"
  },
  "EntityListRow": {
    "validationFailed": "Invalid data",
    "validationDetailsTitle": "Validation error details",
    "tryDisplayAnyway": "Display anyway",
    "hideUnsafePreview": "Hide preview",
    "renderCrashed": "Could not render this item",
    "renderTryAgain": "Try again"
  },
  "EntityGridTileSizeSlider": {
    "size": "Size",
    "thumbnailSizeAria": "Thumbnail size"
  },
  "SortableEntityGrid": {
    "itemsAriaLabel": "Items"
  },
  "EntityEmptyState": {
    "nothingHereYet": "Nothing here yet.",
    "noResultsMatchFilters": "No results match your current filters.",
    "clearFilters": "Clear filters",
    "pageOutOfRangeTitle": "This page does not exist",
    "pageOutOfRangeMessage": "You are on a page that has no results. Go back to the last available page.",
    "goToLastPage": "Go to last page"
  },
  "TableColumnManagerPopover": {
    "title": "Customize columns",
    "shown": "Shown",
    "available": "Available",
    "searchPlaceholder": "Search fields...",
    "reset": "Reset",
    "apply": "Apply",
    "cancel": "Cancel",
    "fixed": "Fixed",
    "noShownResults": "No matching visible fields",
    "noAvailableResults": "No matching available fields",
    "triggerAriaLabel": "Manage columns",
    "availableFieldsCount": "{{count}} field",
    "availableFieldsCount_other": "{{count}} fields",
    "dragHandle": "Drag {{field}}",
    "changed": "Changed",
    "showField": "Show {{field}}",
    "hideField": "Hide {{field}}"
  },
  "TransferToWorkspaceDialog": {
    "fieldCurrentWorkspace": "Current workspace",
    "selectWorkspace": "Select workspace",
    "sameWorkspace": "Choose a different workspace than the current one",
    "save": "Transfer",
    "transferFailed": "Transfer failed. Please try again."
  },
  "TransferToTeamDialog": {
    "fieldCurrentWorkspace": "Current workspace",
    "selectWorkspace": "Select workspace",
    "selectTeam": "Select team",
    "save": "Transfer",
    "transferFailed": "Transfer failed. Please try again."
  },
  "CustomFieldAddFlow": {
    "addTitle": "Add custom field",
    "createTitle": "Create new field",
    "searchPlaceholder": "Search fields or type to create…",
    "createNamed": "Create “{{name}}”",
    "addAsNewHint": "Add as a new custom field",
    "selectFieldsToAdd": "Select fields to add",
    "alreadyAdded": "Already added",
    "currentlyAssigned": "Currently assigned ({{count}})",
    "noCatalog": "No custom fields are available yet. Create one below.",
    "noFieldsAvailable": "No fields available",
    "noFieldsAvailable_search": "No fields match your search",
    "createNewField": "Create new field",
    "saveFields": "Save Fields",
    "cancel": "Cancel",
    "createAndAssign": "Create & assign",
    "stageDescription_search": "Search existing custom fields or create a new one.",
    "stageDescription_create": "Configure the new custom field.",
    "back": "Back",
    "nameValidation_required": "Name is required.",
    "nameValidation_minLength": "Name must contain at least 3 characters.",
    "nameValidation_duplicate": "A custom field with this name already exists."
  },
  "IconPicker": {
    "placeholder": "Pick an icon"
  },
  "ColorPicker": {
    "placeholder": "Pick a color"
  },
  "ColorIconPicker": {
    "placeholder": "Pick icon and color"
  },
  "ResourceTypeIconPicker": {
    "placeholder": "Choose icon"
  },
  "FullPageErrorLog": {
    "copy": "Copy",
    "copied": "Copied"
  },
  "common": {}
}
